module.exports = __webpack_public_path__ + "static/media/bg1.de44984f.jpg";